module.exports = __webpack_public_path__ + "static/media/dorlingCartogram.1495bd5d.svg";